import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";

import { AppSidebar } from "@/components/navigation/app-sidebar";
import { Outlet } from "react-router-dom";
import { Suspense } from "react";
import { TopNavComponent } from "@/components/navigation/top-nav";

type SidebarLayoutProps = {
  hasLanguageSelector: boolean;
};

export const SidebarLayout = ({ hasLanguageSelector }: SidebarLayoutProps) => {
  return (
    <>
      <div className="pr-0 md:pr-4 mt-8 md:pl-20">
        {/* Not the nicest transition but catches suspensions when data fetcuing query fails */}
        <Suspense>
          <Outlet />
        </Suspense>
      </div>
      <SidebarProvider defaultOpen={true}>
        <AppSidebar />
        <SidebarTrigger className="inline md:hidden z-50" />
      </SidebarProvider>
      <TopNavComponent hasLanguageSelector={hasLanguageSelector} />
    </>
  );
};
